module.exports = __webpack_public_path__ + "img/yellow-on-hold.5561875b.svg";